import React, { memo, useCallback, useEffect, useState } from 'react';

import { MetricMonthlySummaryCard } from '../../../components/metricMonthlySummaryCard/MetricMonthlySummaryCard';
import { GradientDefs } from '../../../components/metricMonthlySummaryCard/GradientDefs';
import { isTieredScorecard } from '../../../utils/metricAttainment';
import { SadFolderIllustration } from '../../../components/emptyStateIllustrations/EmptyStateIllustrations';
import './AgentMonthlyMetric.scss';

interface PropTypes {
    monthlyMetricsData: any;
    setMetricName: React.Dispatch<React.SetStateAction<string>>;
    setMetricColorIndex: React.Dispatch<React.SetStateAction<number>>;
}

const AgentMonthlyMetric = memo(({
    monthlyMetricsData,
    setMetricName,
    setMetricColorIndex,
}: PropTypes) => {
    const [selectedMetricName, setSelectedMetricName] = useState<string>('');

    const handleCardClick = useCallback((metricName: string, index: number) => {
        setSelectedMetricName(metricName);
        setMetricName(metricName);
        setMetricColorIndex(index);
    }, [setMetricName, setMetricColorIndex]);

    useEffect(() => {
        if (monthlyMetricsData?.data.length > 0) {
            setMetricName(monthlyMetricsData.data[0].label);
            setSelectedMetricName(monthlyMetricsData.data[0].label);
            setMetricColorIndex(0);
        } else {
            setMetricName('');
            setSelectedMetricName('');
            setMetricColorIndex(0);
        }
    }, [monthlyMetricsData, setMetricName, setMetricColorIndex]);

    if (monthlyMetricsData?.data.length > 0) {
        return (
            <div className="pe-0 ps-0" style={{ backgroundColor: '#FFFFFF' }}>
                <GradientDefs />
                <div className="d-flex flex-nowrap">
                    {monthlyMetricsData.data.map((element: any, index: number) => {
                        const variant = isTieredScorecard(element?.scorecard_calculation_rule_id)
                            ? 'tiered'
                            : 'legacy';
                        return (
                            <div className="flex-grow-1 flex-basis-0" key={element.label}>
                                <MetricMonthlySummaryCard
                                    targetVal={element.target}
                                    metricAttained={element.metric_attained}
                                    metricNameVal={element.label}
                                    metricTypeName={element.metric_type_name}
                                    metricVal={element.metric_value}
                                    metricDesc={element.metric_desc}
                                    metricDirectionId={element.metric_direction_id}
                                    onCardClick={handleCardClick}
                                    selectedMetric={selectedMetricName}
                                    index={index}
                                    metricOmitted={element?.metric_omitted}
                                    variant={variant}
                                    attainmentRank={element?.attainment_rank}
                                    attainmentLevelLabel={element?.metric_attainment_level_label}
                                    targets={element?.targets}
                                    min={element?.min}
                                    max={element?.max}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <div className="agent-monthly-metric-empty">
            <div className="agent-monthly-metric-empty__illustration">
                <SadFolderIllustration />
            </div>
            <div className="agent-monthly-metric-empty__divider" />
            <p className="agent-monthly-metric-empty__title">No Results found for the Performance Period.</p>
        </div>
    );
});

AgentMonthlyMetric.displayName = 'AgentMonthlyMetric';

export default AgentMonthlyMetric;
